export const RESET_SERVICE = 'SERVICE/RESET_SERVICE';
export const SET_SUMMARY_SERVICES = 'SERVICE/SET_SUMMARY_SERVICES';
export const SET_PAGINATION_SERVICE = 'SERVICE/SET_PAGINATION_SERVICE';
export const SET_DETAILED_SERVICE = 'SERVICE/SET_DETAILED_SERVICE';
export const SET_SERVICE_COLLECTION = 'SERVICE/SERVICE_COLLECTION';
export const SET_SERVICES_WARNINGS = 'SERVICE/SET_SERVICES_WARNINGS';
